import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "prefixCls", "size", "shape"];
import * as React from 'react';
import { ConfigContext, SizeContext } from '../ConfigProvider';
export var ButtonGroupContext = /*#__PURE__*/React.createContext({});
export var ButtonGroupProvider = ButtonGroupContext.Provider;

var ButtonGroup = function ButtonGroup(props) {
  var _React$useContext = React.useContext(ConfigContext),
      getPrettyCls = _React$useContext.getPrettyCls;

  var className = props.className,
      prefixCls = props.prefixCls,
      propsSize = props.size,
      shape = props.shape,
      rest = _objectWithoutProperties(props, _excluded);

  var ctxSize = React.useContext(SizeContext);
  var size = React.useMemo(function () {
    return propsSize || ctxSize;
  }, [propsSize, ctxSize]);
  var classString = getPrettyCls('btn-group', prefixCls, className)({
    size: size,
    shape: shape
  });
  return /*#__PURE__*/React.createElement(ButtonGroupProvider, {
    value: {
      size: size,
      shape: shape
    }
  }, /*#__PURE__*/React.createElement("div", _objectSpread({
    className: classString
  }, rest)));
};

export default ButtonGroup;